var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerOverEthernet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 75 75",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "currentColor"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.39066 6.65537c-3.75129 2.10441-3.82785 2.88383-3.90441 31.4883 0 28.9941 0.153114 30.0853 4.21063 31.9559 1.37803 0.62353 7.96193 0.935294 21.436 0.935294 18.6799 0 19.522-0.07794 20.2876-1.55882 0.842127-1.55882 0.612456-1.55882-19.522-1.55882-19.2924 0-20.3642-0.07794-21.8187-1.55882-1.45458-1.48088-1.53114-2.57206-1.53114-28.0588s0.076557-26.578 1.53114-28.0588c1.45458-1.48088 2.52638-1.55882 27.5605-1.55882 25.0341 0 26.1059 0.077941 27.5605 1.55882 1.37803 1.40294 1.53114 2.57206 1.53114 14.8088 0 12.7044 0.07656 13.25 1.53114 13.25 1.45458 0 1.53114-0.545589 1.53114-13.25 0-14.3412-0.459342-16.5235-3.90441-18.3941-2.98572-1.55882-53.743-1.55882-56.4991 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.0139 50.7701-4.59342 9.35295h7.57914l-2.6795 6.00147c-4.66998 10.2882-4.59342 10.2103-0.918684 6.85883 1.83737-1.63677 6.96669-6.85883 11.407-11.6132l8.1916-8.65148-9.64618-0.779413 3.75129-5.3 3.75129-5.22206h-12.2491z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.5 19.5h42v18h-3v-15h-36v21h6v4.5h6v4.5h12v-4.5h9.75l-1.5 3h-5.25v4.5h-18v-4.5h-6v-4.5h-6v-27z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m49.5 25.5h3v10.5h-3v-10.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m45 25.5h3v10.5h-3v-10.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m40.5 25.5h3v10.5h-3v-10.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m36 25.5h3v10.5h-3v-10.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m31.5 25.5h3v10.5h-3v-10.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m27 25.5h3v10.5h-3v-10.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5 25.5h3v10.5h-3v-10.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOverEthernet);
export default __webpack_public_path__ + "static/media/power-over-ethernet.54237bcc4c33fc11d2bdf74f5b9c21cc.svg";
export { ForwardRef as ReactComponent };